import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Row, TextButton, Typography, WithInfoIcon } from 'seagull';
import { PlusCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetClientReferenceFieldsSubsectionTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientReferenceFieldsSubsection(param) {
    let { fields, isReadOnly, onAdd, testId } = param;
    const { ClientReferenceFieldsSubsectionTestIds: TID } = useMemo(()=>GetClientReferenceFieldsSubsectionTID(testId), [
        testId
    ]);
    const { t: texts } = useLocaleKeys('client.detail.summary.clientDetails.referenceFields');
    const showAdd = fields.length === 0 && !isReadOnly;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        testId: TID.Root(),
        children: [
            /*#__PURE__*/ _jsx(WithInfoIcon, {
                info: texts.tooltip(),
                infoTestId: TID.Info(),
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "normal",
                    children: texts.title()
                })
            }),
            fields.map((field, index)=>/*#__PURE__*/ _jsxs(Typography, {
                    testId: TID.Field(index),
                    variant: "paragraph2",
                    breakWords: true,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            variant: "paragraph2",
                            skin: "secondary",
                            children: "".concat(field.name, ": ")
                        }),
                        field.value
                    ]
                }, field.id)),
            showAdd && /*#__PURE__*/ _jsx(Row, {
                children: /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: 'client_detail_add_reference_field'
                    },
                    testId: TID.AddButton(),
                    variant: "paragraph2",
                    skin: "primary",
                    underline: "none",
                    prefixIcon: /*#__PURE__*/ _jsx(PlusCircle, {
                        size: 20
                    }),
                    onClick: onAdd,
                    children: texts.add()
                })
            })
        ]
    });
}
